import { render, staticRenderFns } from "./ConfirmationPopup.vue?vue&type=template&id=704e4c22&scoped=true&"
import script from "./ConfirmationPopup.vue?vue&type=script&lang=ts&"
export * from "./ConfirmationPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmationPopup.less?vue&type=style&index=0&id=704e4c22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704e4c22",
  null
  
)

export default component.exports